import { render, staticRenderFns } from "./index.vue?vue&type=template&id=09f6bb16&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f6bb16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09f6bb16')) {
      api.createRecord('09f6bb16', component.options)
    } else {
      api.reload('09f6bb16', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=09f6bb16&scoped=true", function () {
      api.rerender('09f6bb16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/dangao/lists/index.vue"
export default component.exports